import {th} from '@/i18n/th';
import {en} from '@/i18n/en';

export const DEFAULT_LANGUAGE = 'th';

export const messages = {th, en};

export const SUPPORTED_LANGUAGES = Object.keys(messages);
